import { useFormikContext } from 'formik';

import type { ProjectFormikType } from '@core/formik/project';
import { NewAddress } from '@core/types/api/Address/Address';
import { usePlantDistanceCalculationShared } from '@web/hooks/plantsDistance/usePlantDistanceCalculationShared';

// this hook is listening to the address and plant changes and calculates the distance
// between the address and the plants and updates the formik values
export const usePlantDistanceCalculationForProjects = (): void => {
  const formikBag = useFormikContext<ProjectFormikType>();

  const plants = formikBag.values.productsByPlants;

  usePlantDistanceCalculationShared({
    effectiveAddress: NewAddress(formikBag.values?.address),
    setFieldValue: formikBag.setFieldValue,
    plantSections: plants.map((plant, index) => ({
      plantId: plant.plant?.id ?? null,
      formikPath: `productsByPlants.${index}`,
      products: plant.products,
    })),
    setPlantFields: (formikPath, { distanceInUnit, driveTimeISO, unit }) => {
      formikBag.setFieldValue(`${formikPath}.plantDistance`, distanceInUnit);
      formikBag.setFieldValue(`${formikPath}.plantDistanceUnit`, unit);
      formikBag.setFieldValue(`${formikPath}.plantDriveTime`, driveTimeISO);
    },
  });
};
